module.exports = __webpack_public_path__ + "img/editButtonW.b183fad1.png";